import { InstructionProps } from "../types";
import styles from "../style.module.css";
import ButtonLink from "../../../components/button-link";
import { isTelegramWebApp } from "../../../utils/telegram";
import CopyText from "../../../components/copytext";
const APK_HREF = "/Happ.apk";

const InstructionAndroid = ({accessData}: InstructionProps) => {
  const handleOpenHappWithConfig = () => {
    const happUrl = `happ://add/${accessData}`;
    if (isTelegramWebApp()) {
      const openedWindow = window.open(happUrl, "_blank");
      if (openedWindow) {
        return;
      }
    }

    window.location.assign(happUrl);
  };
  
  
  return (
    <>
      <h1>Настройка на Android</h1>
      <p>Займет 2 минуты</p>
      <hr className={styles.separator}/>
      <div className={styles.step}>
        <h2>Шаг 1</h2>
        <p>Установите приложение Happ через Google Play или файлом вручную, кликнув кнопку ниже. В нем вы будете включать и выключать VPN.</p>
        <ButtonLink label={"Установить в Google Play"} href="https://play.google.com/store/apps/details?id=com.happproxy"></ButtonLink>
        <div style={{marginTop: "10px"}}>
        <ButtonLink
          label={"Скачать файл"}
          href={APK_HREF}
          onClick={() => {
            if (isTelegramWebApp()) {
              // @ts-ignore
              const tg = window.Telegram?.WebApp;
              if (tg?.openLink) {
                tg.openLink(new URL(APK_HREF, window.location.origin).toString());
                return;
              }
            }
            window.location.href = APK_HREF;
          }}
        ></ButtonLink>
        </div>
      </div>
      <div className={styles.step}>
        <div style={{backgroundColor: "var(--transperent-white-70)", padding: "16px", borderRadius: "16px", marginTop: "16px", border: "1px solid var(--transperent-white-100)"}}>
          <h3 style={{ marginTop: "0", display: "flex", alignItems: "center", gap: "4px"}}><img style={{width: "20px", height: "20px"}} src="/images/instruction/android/icon-save.svg" alt="Security" /> Файл безопасен</h3>
          <p>Предоставлен <a href="https://www.happ.su/main/ru" target="_blank" rel="noreferrer">официальным разработчиком</a> и не содержит угроз. Вы можете убедиться в этом самостоятельно, используя <a href="https://www.virustotal.com/gui/home/upload" target="_blank" rel="noreferrer">VirusTotal</a></p>
        </div>
      </div>


      <div className={styles.step}>
        <h2>Шаг 2</h2>
        <p>Нажмите кнопку ниже, чтобы добавить подписку. Приложение откроется и подписка добавится автоматически.</p>
        <ButtonLink label={"Добавить подписку"} href="happ://" onClick={handleOpenHappWithConfig}></ButtonLink>
      </div>
      <div className={styles.step}>
        <h2>Или</h2>
        <p>Если добавление подписки по кнопке не работает, добавьте ее вручную.</p>
        <h3>Скопируйте ссылку</h3>
        <CopyText text={accessData}></CopyText>
        <h3 style={{marginTop: "20px"}}>Откройте приложение Happ</h3>
        <p>Нажмите + в правом углу экрана. В открывшемся окне выберите «Вставить из буфера обмена».</p>
      </div>



      <div className={styles.step}>
        <h2>Шаг 3</h2>
        <p>На главном экране приложения появилась подписка Openway. Выберите сервер или оставьте тот, который выбран по умолчанию.</p>
        <div style={{backgroundColor: "var(--transperent-white-70)", padding: "16px", borderRadius: "16px", marginTop: "16px",marginBottom: "16px", border: "1px solid var(--transperent-white-100)"}}>
          <h3 style={{ marginTop: "0", display: "flex", alignItems: "center", gap: "4px"}}><img style={{width: "20px", height: "20px"}} src="/images/instruction/android/icon-save.svg" alt="Security" /> Обход белых списков</h3>
          <p style={{margin: 0}}>Чтобы обходить белые списки, выберите сервер «Обход глушилок»</p>
        </div>
        <img className={styles.image} src="/images/instruction/android/Android_1.webp" alt="Step 3"/>
      </div>
     
      <div className={styles.step}>
        <h2>Шаг 4</h2>
        <p>Нажмите на кнопку в центре, чтобы включить VPN.</p>
        <img className={styles.image} src="/images/instruction/android/Android_2.webp" alt="Step 4"/>
      </div>
     
      <div className={styles.step}>
        <h2>Готово</h2>
        <p>Включайте и выключайте VPN, используя это приложение.</p>
        <img className={styles.image} src="/images/instruction/android/Android_3.webp" alt="Step 5"/>
      </div>

    </>
  );
};

export default InstructionAndroid;